import './SelectDropdown.scss'
import React, { useState } from 'react'
import { ReactComponent as ArrowDownIcon } from '../../icons/arrows-down-solid.svg'

interface Props {
  options: Array<{ label: any; value: string }>
  value?: string
  onChange: (selected: string) => void
  className?: string
  disabled?: boolean
}

export default function SelectDropdown({
  value,
  onChange,
  options,
  className = '',
  disabled = false
}: Props): React.ReactElement {
  const [showMenu, setShowMenu] = useState(false)

  const handleOptionClick = (selectedValue: string): void => {
    setShowMenu(false)
    onChange(selectedValue)
  }

  const toggleMenu = (): void => {
    if (!disabled) {
      setShowMenu(!showMenu)
    }
  }

  return (
    <div
      className={`SelectDropdown ${className} ${disabled ? 'disabled' : ''} ${showMenu ? 'active' : ''}`}
      onClick={toggleMenu}
    >
      <div className="SelectDropdown__input">
        <span>
          {options.find((option) => option.value === value)?.label ?? 'Select'}
        </span>
        {!disabled && <ArrowDownIcon />}
      </div>

      {showMenu && !disabled && (
        <div className="collapse-menu">
          <ul>
            {options.map((option) => (
              <li
                key={option.value}
                onClick={() => handleOptionClick(option.value)}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
